import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";

export const directObjectPronounsExplanation: ExplanationModel = {
    title: "📖 What are Pronombres de Objeto Directo?",
    description: `
Direct object pronouns are used to replace the noun that directly receives the action of the verb.
They answer the questions: What? or Whom? after the verb.
  `.trim(),
    examples: [
        "I see the car. → Lo veo.",
        "She eats the apple. → La come.",
        "They love the dog. → Los aman.",
    ],
    bulletPoints: [
        "Replaces the noun that directly receives the action of the verb.",
        "Agrees in gender and number with the noun it replaces.",
        "Examples of direct object pronouns: Lo (it/him), La (it/her), Los (them, masculine), Las (them, feminine).",
    ],
};

  
export const combinedExamples: Example[] = [
    {
        sentence: "Le doy el libro a Juan y veo el coche.",
        explanation:
            "In this sentence, 'Le' replaces 'Juan' as the indirect object, 'el libro' is the direct object, and 'veo el coche' indicates that the action is being done to 'the car.'",
    },
    {
        sentence: "Se lo cuento a ellos y se lo doy a él.",
        explanation:
            "In this sentence, 'Se' replaces 'a ellos' (the indirect object) and 'a él' (the indirect object). 'Lo' replaces 'el libro' (the direct object). The same pronoun 'lo' is used for both actions—telling and giving.",
    },
    {
        sentence: "Les envío el paquete y les doy las llaves.",
        explanation:
            "Here, 'Les' replaces 'a ellos/ellas' as the indirect object. 'El paquete' and 'las llaves' are the direct objects of the verbs 'enviar' and 'dar.' Both indirect objects are replaced with 'les.'",
    },
    {
        sentence: "Te lo explico a ti y te lo doy ahora.",
        explanation:
            "In this sentence, 'Te' replaces the indirect object 'a ti.' 'Lo' replaces 'el tema' (the topic), indicating what is being explained and given.",
    },
    {
        sentence: "Nos lo trajeron y nos lo mostraron.",
        explanation:
            "In this example, 'Nos' replaces 'a nosotros' as the indirect object. 'Lo' replaces the direct object that was brought and shown.",
    },
];
